/*
 * @Author: tanyaohua
 * @Date: 2022-03-01 17:03:37
 * @FilePath: \MCN_new\app\main\submissionManage\personalLibrary\service.js
 * @Description: 
 */
/*
 * @Author: cc
 * @Date: 2019-12-08 19:24:26
 * @LastEditTime: 2022-03-01 17:26:46
 * @LastEditors: Please set LastEditors
 * @FilePath: \xjmediacloud\app\editingCenter\service\uploadVideoForXj\uploadService.js
 * @Description:视频上传公共服务
 */

angular.module('persinalLibrary', []).factory('persinalLibraryService', [
    '$q',
    '$sce',
    'httpService',
    function ($q, $sce, httpService) {
        return {
            /**
            * [editVideo description]获取视频的详细信息
            * @param   {[obj]}   list     [list description]稿件对象
            * @return  {[promise]}        [return description]promise对象
            */    
            getVideoDetail: function (id) {
                var defer = $q.defer();
                var params = {
                    tenantId: '3',
                    userId: 'AAAABQAMdGVzdEB0cnMuY29tABx0ZXN0QHRycy5jb20sMywxNTc4ODg4Nzg1Nzk4AAAALzAtAhUAkYbTEsbpfqXrVG9_psU_CpwT5lkCFFw1Gq_Hk3yYL89R0fi3yw9f8koN',
                    videoId: id
                };
                httpService.http('/transfer/aav/video/detail', params, 'get').then(function (data) {
                    if (data.data) {
                        if (data.data.videoUrl) {
                            defer.resolve($sce.trustAsResourceUrl(data.data.videoUrl));
                        }
                    }
                    if (data.datas) {
                        defer.resolve($sce.trustAsResourceUrl(data.datas.videourl));;
                    }
                }, function(data) {
                    defer.reject(data);
                });
                return defer.promise;
            },
        };
    },
]);
